import { SessionEngagementTotals } from '@/types/module.types';
import { Get } from '../helpers';

export const GetSessionEngagementTotals = (sessionUuid: string): Promise<SessionEngagementTotals[]> => {
  return Get({ path: `/v3/admin/events/sessions/engagement/totals/${sessionUuid}` });
};
